import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import ActivityLogTable from "./LogsList/ActivityLogsTable";
import BreadCrumb from "../../Common/BreadCrumb";
import {useTranslation} from "react-i18next";
import { dashboardAPI } from "../../services/api";

const ActivityLogPage = () => {
    const {t} = useTranslation();
    const [logs, setLogs] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    
    // Get Redux logs for demo users
    const reduxLogs = useSelector((state: any) => state.Logs?.activityLogs || []);
    
    // Check if demo user
    const isDemoUser = () => {
        const user = sessionStorage.getItem("authUser");
        if (!user) return false;
        try {
            const userData = JSON.parse(user);
            const token = userData.token || userData.access_token;
            return token && typeof token === 'string' && token.startsWith('demo-token-');
        } catch {
            return false;
        }
    };

    useEffect(() => {
        const fetchLogs = async () => {
            setIsLoading(true);
            setError(null);
            try {
                if (isDemoUser()) {
                    // Use Redux for demo users
                    setLogs(reduxLogs);
                } else {
                    // Fetch from backend for real users
                    const fetchedLogs = await dashboardAPI.getActivityLogs();
                    setLogs(fetchedLogs || []);
                }
            } catch (err: any) {
                console.error('Error fetching activity logs:', err);
                setError(err?.message || t('Common.error_loading_data'));
            } finally {
                setIsLoading(false);
            }
        };

        fetchLogs();
    }, []);

    // For demo users, also listen to Redux changes
    useEffect(() => {
        if (isDemoUser() && reduxLogs.length > 0) {
            setLogs(reduxLogs);
        }
    }, [reduxLogs]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb
                        items={[
                            {label: t('Dashboard.header'), path: "/"},
                            {label: t('ActivityLogs.page_title'), path: "/activity-logs"}
                        ]}
                    />
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    {isLoading ? (
                                        <div className="text-center py-5">
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden">{t('Common.loading')}</span>
                                            </Spinner>
                                        </div>
                                    ) : error ? (
                                        <Alert variant="danger" dismissible onClose={() => setError(null)}>
                                            {error}
                                        </Alert>
                                    ) : (
                                        <ActivityLogTable data={logs} />
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>

    );
};

export default ActivityLogPage;
